module.exports = "<app-ssn-bg header=\"PORT CALL REGISTRATION\" icon=\"portcall.png\">\r\n  <app-forms></app-forms>\r\n</app-ssn-bg>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-content/content-container/port-call/registration/registration.component.html
// module id = ./src/app/main-content/content-container/port-call/registration/registration.component.html
// module chunks = main